<template>
  <div v-resize="onResize" :data-ribbon="uuid" :class="[baseCss, 'text-xs', 'select-none', 'text-base', setOutline('toolsBgColor', 'toolsBgColorLightness')]">
    <card :overflow-off="false" :rounded="false" elevation="none">
      <card-text :padding-off="true">
        <container :class="[`${baseCss}-quick-launch`, 'truncate', 'whitespace-nowrap', setBgColor('tabPanelsBgColor', 'tabPanelsBgColorLightness')]" v-if="icon || (tools['quick-launch'] && tools['quick-launch'].length)">
          <ul :class="['inline-list', 'whitespace-nowrap', 'truncate', 'align-middle']">
            <li v-if="icon" :class="['m-0.5', 'p-0.5', 'align-middle']">
              <icon :size="1.75" :name="icon" :icon-provider="iconProvider" :color="toolsBgColor" :color-lightness="toolsBgColorLightness" />
            </li><li v-ripple v-for="(command, index) in tools['quick-launch']" :key="index" :class="['m-0.5', 'align-middle', 'p-0.5', 'quick-launch', 'cursor-pointer', command.disabled ? 'disabled': null]" :title="command.hint">
              <icon @click="emitCommand('quick-launch', [command.value], 'quick-launch-btn')" :size="1.25" :icon-provider="iconProvider" :name="command.icon" :color="toolsBgColor" :color-lightness="toolsBgColorLightness" />
            </li>
          </ul>
        </container>
        <tab @change="onTabChange" :selected-marker-color="tabPanelsBgColor" :selected-marker-color-lightness="tabPanelsBgColorLightness" :bg-color="toolsBgColor" :bg-color-lightness="toolsBgColorLightness" :color="toolsColor" :color-lightness="toolsColorLightness" :bold="false" :uppercase="false" :name="`tab-${uuid}`" :padding-off="true" :dense="true" :icon-provider="iconProvider" :default-tab="defaultTab">
          <tab-panel :class="[setBgColor('tabPanelsBgColor', 'tabPanelsBgColorLightness')]" overflow="visible" :disabled="tabPanel.disabled" v-for="(tabPanel, tabPanelIndex) in tools.tabs" :icon="tabPanel.icon" :key="tabPanelIndex" :label="tabPanel.label">
            <table-layout v-if="tabPanel.ribbons && tabPanel.ribbons.length">
              <row>
                <cell :style="{width: ribbon.width}" v-for="(ribbon, ribbonIndex) in tabPanel.ribbons" :key="ribbonIndex" :class="[ribbonPadding(ribbonIndex, tabPanel.ribbons.length), 'py-1']">
                  <card bg-color="transparent" :bg-color-lightness="null" full-height :overflow-off="false" :rounded="rounded" :elevation="elevation">
                    <card-text :padding-off="true" :class="[`${baseCss}-ribbon-content`, rounded ? 'rounded-t' : null, 'min-h-full']">
                      <div :class="[['break'].includes(tool.type) ? 'block' : ['inline-block', 'align-middle', 'p-0.5']]" v-if="ribbon.tools && ribbon.tools.length" v-for="(tool, toolIndex) in ribbon.tools" :key="toolIndex">
                        <btn-group :outlined="true" v-if="tool.type === 'btn-group'" v-model="tool.model" @input="emitCommand(tool.name, $event, tool.type, tabPanelIndex, ribbonIndex, toolIndex)" size="xs" :separators="true" :align="tool.defs.align" :uppercase="false" :bold="false" :bg-color="toolsBgColor" :bg-color-lightness="toolsBgColorLightness" :color="toolsBgColor" :color-lightness="toolsBgColorLightness" :rounded="rounded" :elevation="elevation" :disabled="tool.defs.disabled" :vertical="tool.defs.vertical" :mandatory="tool.defs.mandatory" :type="tool.defs.type" :icon-provider="iconProvider" :buttons="tool.defs.commands" />
                        <menu-list :outlined="true" :title="tool.defs.hint" :width="tool.defs.width" :opener="tool.defs.opener || 'btn'" v-if="tool.type === 'menu-list'" size="xs" :uppercase="false" :bold="false" :rounded="rounded" :elevation="elevation" :bg-color="toolsBgColor" :bg-color-lightness="toolsBgColorLightness" :color="toolsBgColor" :color-lightness="toolsBgColorLightness" :disabled="tool.defs.disabled" :header-text="tool.defs.label" :icon="tool.defs.icon">
                          <template v-slot:list>
                            <list>
                              <list-item @click="onMenuListItemClick(tool.name, item.value, tool.type, tabPanelIndex, ribbonIndex, tool.defs.opener || 'btn', tool.defs, index, toolIndex)" v-for="(item, index) in tool.defs.commands" :key="index" :class="[tool.defs.opener === 'split-btn' && tool.defs.selectedIndex ===  index ? 'bcq-list-item-selected' : null]" :disabled="item.disabled">
                                <list-item-icon v-if="item.icon">
                                  <icon :icon-provider="iconProvider" :name="item.icon" :color="toolsBgColor" :color-lightness="toolsBgColorLightness" />
                                </list-item-icon>
                                <list-item-content v-if="item.title || item.subTitle">
                                  <list-item-content-title v-if="item.title" v-html="item.title" />
                                  <list-item-content-sub-title v-if="item.subTitle" v-html="item.subTitle" />
                                </list-item-content>
                              </list-item>
                            </list>
                          </template>
                        </menu-list>
                        <dropdown v-model="tool.model" v-if="tool.type === 'dropdown'" @input="emitCommand(tool.name, tool.model, tool.type, tabPanelIndex, ribbonIndex, toolIndex)" :width="tool.defs.width" :dense="true" :items="tool.defs.commands" :disabled="tool.defs.disabled" :color="toolsBgColor" :color-lightness="toolsBgColorLightness" :multiple="tool.defs.multiple" />
                        <color-picker :disabled="tool.defs.disabled" :title="tool.defs.hint" :tile="!rounded" :icon-provider="iconProvider" :icon-size="1" @input="emitCommand(tool.name, [tool.model], tool.type, tabPanelIndex, ribbonIndex, toolIndex)" :icon="tool.defs.icon" :label="false" size="24px" :padding-off="true" v-model="tool.model" v-if="tool.type === 'color-picker'" />
                        <checkbox @input="emitCommand(tool.name, [tool.model], tool.type, tabPanelIndex, ribbonIndex, toolIndex)" v-model="tool.model" :icon-color="toolsBgColor" :disabled="tool.defs.disabled" label-size="xs" :icon-color-lightness="toolsBgColorLightness" v-if="tool.type === 'checkbox'" :label="tool.defs.label" :indeterminate="tool.defs.indeterminate" />
                        <radio-group @input="emitCommand(tool.name, [tool.model], tool.type, tabPanelIndex, ribbonIndex, toolIndex)" v-if="tool.type === 'radio-group'" label-size="xs" :name="tool.name" :disabled="tool.defs.disabled" v-model="tool.model">
                          <radio v-for="(radio, index) in tool.defs.radios" :value="radio.value" :label="radio.label" :key="index" :icon-color="toolsBgColor" :disabled="radio.disabled" :icon-color-lightness="toolsBgColorLightness" />
                        </radio-group>
                        <text-field @input="emitCommand(tool.name, [tool.model], tool.type, tabPanelIndex, ribbonIndex, toolIndex)" type="number" :readonly="tool.defs.readonly" :color="toolsBgColor" :disabled="tool.defs.disabled" :color-lightness="toolsBgColorLightness" :icon-provider="iconProvider" :icon-left="tool.defs.icon" v-if="tool.type === 'numeric-input'" v-model="tool.model" />
                      </div>
                    </card-text>
                    <card-title align="center" :padding-off="true" :bold="false" :class="['p-0.5', rounded ? 'rounded-b' : null]" :color="toolsColor" :color-lightness="toolsColorLightness" :bg-color="toolsBgColor" :bg-color-lightness="toolsBgColorLightness">
                      <div v-html="ribbon.label" :class="['truncate', 'text-xs']" />
                    </card-title>
                  </card>
                </cell>
              </row>
            </table-layout>
          </tab-panel>
        </tab>
      </card-text>
    </card>
    <reactive-style>
    .bcq-ribbon[data-ribbon="{{ uuid }}"] .bcq-ribbon-ribbon-content {
      min-height: {{ ribbonHeight ? ribbonHeight + 'px' : 'auto' }};
    }
    </reactive-style>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'Ribbon',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      uuid: this.$uuidv4(),
      ribbonHeight: 'auto',
      baseCss: this.componentBaseCss('ribbon', [])
    }
  },
  props: {
    tools: {
      type: Object,
      default: () => {
        return {}
      }
    },
    debug: {
      type: Boolean
    },
    icon: {
      type: String
    },
    defaultTab: {
      type: Number,
      default: 0
    },
    rounded: {
      type: Boolean,
      default: true
    },
    toolsColor: {
      type: String,
      default: 'black'
    },
    toolsColorLightness: {
      type: Number,
      default: null
    },
    toolsBgColor: {
      type: String,
      default: 'gray'
    },
    toolsBgColorLightness: {
      type: Number,
      default: 300
    },
    elevation: {
      type: String,
      default: 'md'
    },
    tabPanelsBgColor: {
      type: String,
      default: 'white'
    },
    tabPanelsBgColorLightness: {
      type: Number,
      default: null
    },
    commands: {
      type: Array,
      default: () => {
        return []
      }
    },
    toggleToolDisabled: {
      type: Object,
      default: null
    },
    toggleToolItemDisabled: {
      type: Object,
      default: null
    }
  },
  watch: {
    toggleToolItemDisabled () {
      const toolToToggle = this.toggleToolItemDisabled
      const type = toolToToggle.type
      const itemIndex = toolToToggle.itemIndex
      switch (type) {
        case 'quick-launch':
          const qlDisabled = this.tools['quick-launch'][itemIndex].disabled
          this.tools['quick-launch'][itemIndex].disabled = !qlDisabled
          break
        case 'btn-group':
        case 'menu-list':
        case 'dropdown':
          const tool = this.tools.tabs[toolToToggle.tab].ribbons[toolToToggle.ribbon].tools[toolToToggle.toolIndex].defs.commands[itemIndex]
          const btnGroupDisabled = tool.disabled
          tool.disabled = !btnGroupDisabled
          break
      }
    },
    toggleToolDisabled () {
      const toolToToggle = this.toggleToolDisabled
      const tool = this.tools.tabs[toolToToggle.tab].ribbons[toolToToggle.ribbon].tools[toolToToggle.toolIndex]
      const disabled = tool.defs.disabled
      tool.defs.disabled = !disabled
    },
    tools () {
      this.setRibbonsHeight()
    },
    commands () {
      const tabs = this.tools.tabs
      this.commands.forEach(command => {
        const tool = tabs[command.tab].ribbons[command.ribbon].tools[command.toolIndex]
        const type = command.type
        switch (type) {
          case 'btn-group':
            const commandIndex = tool.model.findIndex(cmd => cmd === command.data)
            const exclusive = command.exclusive
            if (!exclusive) {
              if (commandIndex === -1) {
                tool.model.push(command.data)
              } else {
                tool.model.splice(commandIndex, 1)
              }
            } else {
              tool.model = [command.data]
            }
            break
          case 'checkbox':
          case 'color-picker':
          case 'radio-group':
          case 'numeric-input':
            tool.model = command.data
            break
          case 'dropdown':
            tool.model = [command.data]
            break
        }
      })
    }
  },
  mounted () {
    this.setRibbonsHeight()
    this.log('mounted', this.tools)
  },
  methods: {
    log (event, data) {
      if (this.debug) {
        console.log('[ribbon:debug]', `@${event}`, data)
      }
    },
    onResize () {
      this.setRibbonsHeight()
      this.log('resize', null)
    },
    setRibbonsHeight () {
      const ribbons = this.$el.querySelectorAll('.bcq-ribbon-ribbon-content')
      const heights = []
      this.ribbonHeight = null
      this.$nextTick(() => {
        ribbons.forEach(ribbon => {
          heights.push(ribbon.offsetHeight)
        })
        this.ribbonHeight = Math.max.apply(Math, heights)
      })
    },
    ribbonPadding (index, ribbonsLength) {
      if (index === 0) {
        return ['pr-0.5', 'pl-1']
      } else if (index === ribbonsLength - 1) {
        return ['pl-0.5', 'pr-1']
      } else {
        return ['px-0.5']
      }
    },
    onTabChange (data) {
      const event = 'tab-change'
      const eventData = {
        tab: data.selectedTab
      }
      this.$emit(event, eventData)
      this.log(event, eventData)
    },
    emitCommand (command, data, tool, tab, ribbon, toolIndex) {
      const event = 'command'
      const eventData = {tab, tool, ribbon, command, data, toolIndex}
      this.$emit(event, eventData)
      this.log(event, eventData)
    },
    onMenuListItemClick (command, data, tool, tab, ribbon, opener, defs, index, toolIndex) {
      if (opener === 'split-btn') {
        defs.selectedIndex = index
        defs.label = defs.commands[index].title
      }
      this.emitCommand(command, [data], tool, tab, ribbon, toolIndex)
    }
  }
}
</script>
<style>
.bcq-ribbon .bcq-checkbox .bcq-table-layout-cell,
.bcq-ribbon .bcq-radio .bcq-table-layout-cell
{
  padding-top: 3px;
  padding-bottom: 3px;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/ribbon/ribbon.vue